<template>
  <TipTapRenderer :content="modelValue" :mode="props.mode" />
</template>

<script setup lang="ts">
import TipTapRenderer from '../../render/lib/TipTapRenderer.vue'
const modelValue = defineModel<{ content: Array<object> }>({
  required: false,
})
const props = withDefaults(
  defineProps<{
    mode?: 'doc' | 'single' | 'plain'
  }>(),
  {
    mode: 'doc',
  },
)
</script>
